import React from "react";

const EffectivenessNote = () => {
  return (
    <div className="bg-gray-10 p-2  flex flex-col max-w-[355px] ">
      <p className="text-teal-300 text-sm  font-normal">
        <ul class="pl-6 list-disc">
          <li>Dose</li>
          <li>Dosage form;</li>
          <li>Frequency inappropriate</li>
          <li>Condition refractory to drug,</li>
          <li>Drug not effective for condition,</li>
          <li>There may be a more effective drug</li>
          <li>Needs additional therapy</li>
        </ul>
      </p>
    </div>
  );
};

export default EffectivenessNote;
